import { Content } from '@prismicio/client';
import type { Simplify } from '../../../../../../prismicio-types';

import styles from './loanUsesHeroCards.module.scss';
import { OptimizedPrismicImage } from '@/components';
import { LoanUsesHeroRange } from './LoanUsesHeroRange/LoanUsesHeroRange';
import { useVisible } from '@/hooks';

interface LoanUsesHeroCardsProps {
  data: Simplify<Content.HeroSliceLoanUsesPrimary>;
}

export const LoanUsesHeroCards = ({ data }: LoanUsesHeroCardsProps) => {
  const [isVisible, id] = useVisible();
  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <article className={styles.cards_content} id={id}>
      <div className={styles.loan_content}>
        <div className={`${styles.term} ${isVisibleStyles}`}>{data.term}</div>
        <div className={`${styles.rate} ${isVisibleStyles}`}>
          <div className={styles.value}>
            <span>{data.interest_rate_value}</span>
            <OptimizedPrismicImage field={data.interest_rate_icon} />
          </div>
          <span>{data.interest_rate_text}</span>
        </div>
        <div className={`${styles.loan} ${isVisibleStyles}`}>
          <div className={styles.loan_value}>
            <span>{data.amound_value}</span>
            <span>{data.amount_heading}</span>
          </div>
          <div className={styles.range}>
            <span>{data.range_heading}</span>
            <LoanUsesHeroRange isVisible={isVisible} />
          </div>
          <OptimizedPrismicImage
            field={data.personal_loan_card_background_image}
            className={styles.loan_background}
          />
        </div>
      </div>
      <div className={`${styles.client_photo} ${isVisibleStyles}`}>
        <OptimizedPrismicImage field={data.client_photo} />
      </div>
    </article>
  );
};
